import { XIcon } from 'lucide-react';
import { Button } from '~/modules/ui/button';
import { cn } from '~/utils/cn';

const sizeConfig = {
  sm: { icon: 'icon-md', button: 'size-6' },
  md: { icon: 'icon-lg', button: 'size-7' },
  lg: { icon: 'icon-xl', button: 'size-8' },
} as const;

interface CloseButtonProps {
  onClick: () => void;
  size?: keyof typeof sizeConfig;
  className?: string;
}

export function CloseButton({ onClick, size = 'md', className }: CloseButtonProps) {
  const { icon, button } = sizeConfig[size];

  return (
    <Button
      variant="ghost"
      size="icon"
      className={cn(button, 'opacity-70 hover:opacity-100', className)}
      onClick={onClick}
    >
      <XIcon className={icon} strokeWidth={1.5} />
    </Button>
  );
}
